import {
  type DatePickerInputProps,
  type DatePickerType,
  DatePickerInput as MantineDatePickerInput,
} from "@mantine/dates";
import React from "react";

type Props<Type extends DatePickerType> = DatePickerInputProps<Type> & {
  ref?: React.Ref<HTMLButtonElement>;
};

export const DatePickerInput = React.forwardRef<
  HTMLButtonElement,
  Props<DatePickerType>
>((props, ref) => {
  const { ...datePickerInputProps } = props;
  const defaultOption: DatePickerInputProps = {
    defaultLevel: "decade",
    valueFormat: "YYYY/MM/DD",
    yearsListFormat: "YYYY",
    yearLabelFormat: "YYYY年",
    monthsListFormat: "MM",
    monthLabelFormat: "YYYY年MM月",
    hideWeekdays: true,
    locale: "ja",
  };
  const option = Object.assign({}, defaultOption, datePickerInputProps);

  return <MantineDatePickerInput ref={ref} {...option} />;
});

DatePickerInput.displayName = "DatePickerInput";
